<template>
  <div class="nuser-wrapper">
    <Title
      title="智慧照护"
      subTitle="Intelligent Care"
      @showMore="showMore"
    ></Title>
    <!-- 数字 -->
    <div class="count-con">
      <div class="count-item" v-for="item in count_data" :key="item.title">
        <div class="count-title">{{ item.title }}</div>
        <div class="num">{{ item.count }} <span class="unit">次</span></div>
      </div>
    </div>
    <div class="content">
      <div class="left-con">
        <div class="bed-code">
          <div class="title">一床一码（绑定/解绑）</div>
          <div class="num">
            {{ nurseData.bedCodeBind
            }}<span>/{{ nurseData.bedCodeUnBind }}</span>
          </div>
        </div>
        <div class="help-sos">
          <div class="title">紧急救助</div>
          <div class="num">{{ nurseData.bailout || 0 }} <span>次</span></div>
        </div>
      </div>
      <div class="right-con">
        <div class="chart-title">老人照护等级分布</div>
        <div id="nurse-chart2"></div>
      </div>
    </div>
    <div class="line-chart-con">
      <div class="title-item">
        <div class="title-icon"></div>
        <div>照护服务统计</div>
      </div>
      <div id="line-chart2"></div>
    </div>
    <div class="title-through">今日院内照护情况</div>
    <div class="nurse-data-con">
      <div class="data-item">
        <div class="title">项目总数</div>
        <div class="num">
          {{ nurseData.todayTakeCarePlanCount }} <span>次</span>
        </div>
      </div>
      <div class="data-item">
        <div class="title">已完成</div>
        <div class="num">
          {{ nurseData.todayTakeCarePlanFinish }}<span>次</span>
        </div>
      </div>
      <div class="data-item">
        <div class="title">未完成</div>
        <div class="num">
          {{ nurseData.todayTakeCarePlanUnFinish }}<span>次</span>
        </div>
      </div>
      <div class="data-item">
        <div class="title">完成率</div>
        <div class="num">
          {{ nurseData.todayTakeCarePlanRatio }}<span>%</span>
        </div>
      </div>
    </div>
    <div class="nurse-record-con">
      <div class="record-title">
        <div class="title-con">
          <div class="icon"></div>
          <div class="title">照护记录</div>
        </div>
        <div class="more" @click="showNurseModal">更多</div>
      </div>
      <dv-scroll-board
        :config="record_config"
        style="width: 500px; height: 150px"
      />
    </div>
    <div class="device-con">
      <div class="device-title">
        <div class="icon"></div>
        <div class="title">
          设备类型占比 &nbsp&nbsp共
          <span>{{ nurseData.iotDeviceCount }} </span>台
        </div>
      </div>
      <div id="device-chart"></div>
    </div>

    <!-- 照护记录弹窗 -->
    <el-dialog
      title="照护服务明细"
      :visible.sync="monitorShow"
      append-to-body
      width="950px"
    >
      <div>
        <SelectCityMechanism
          :buildingId.sync="searchObj.buildingId"
          :floorId.sync="searchObj.floorId"
          :branchId.sync="searchObj.branchId"
        ></SelectCityMechanism>
        <el-input
          v-model="searchObj.elderNameLike"
          clearable
          placeholder="长者"
          size="small"
          class="mgr-20 input"
        ></el-input>
        <el-select
          clearable
          size="small input"
          class="mgr-20"
          v-model="searchObj.expenseItemId"
          placeholder="服务项目"
        >
          <el-option
            v-for="item in serviceTypeList"
            :key="item.bean.id"
            :label="item.caption.expenseItemId"
            :value="item.bean.expenseItemId"
          ></el-option>
        </el-select>
        <el-button
          type="primary"
          size="mini"
          @click="apiGetServiceRecordListFunc"
        >
          查询
        </el-button>
        <!-- 表格 -->
        <el-table
          :data="serviceData"
          style="width: 100%; margin-top: 20px"
          border
          max-height="500"
          size="mini"
        >
          <el-table-column
            prop="elderName"
            label="服务对象"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="bedNo"
            label="床号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="executor"
            label="服务人员"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="finishTime"
            label="服务时间"
            align="center"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="expenseItem"
            label="服务项目"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="resultDesc"
            label="执行结果"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
          ></el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          class="pageing"
          @size-change="mixinPagingSelectSize"
          @current-change="mixinPagingCurrentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paging.total"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Title from "@/components/Commen/CloseTitle";
const echarts = require("echarts");
import roseChart from "./charts/care";
import roseChart2 from "./charts/roseChart";
import lineChart from "./charts/line";
import { mapState } from "vuex";
import SelectCityMechanism from "@/components/selectBranch";
import { presentTime } from "@/utils/date";

import {
  planRecordBeanList,
  findBizServicePlanItemElementList,
} from "../../api/service";
export default {
  components: {
    Title,
    SelectCityMechanism,
  },
  watch: {
    "searchObj.floorId"(newVal) {
      if (!this.create) {
        this.create = true;
        this.apiGetServiceRecordListFunc(); // 获取服务记录明细列表
      }
    },
  },
  computed: {
    ...mapState(["nurseData"]),
  },
  data() {
    return {
      monitorShow: false,
      count_data: [
        {
          title: "能力评估",
          count: 36,
        },
        {
          title: "需求评估",
          count: 218,
        },
        {
          title: "照护计划",
          count: 218,
        },
        {
          title: "响应次数",
          count: 218,
        },
      ],
      service_data: {},
      level_data: [],
      device_data: [],
      searchObj: {
        branchId: "",
        buildingId: "", // 城市id
        floorId: "", // 城市id
        elderNameLike: "", // 长者姓名
        expenseItemId: "", // 服务项目id
        // planFinishDateFin1: presentTime(), // 开始时间
        // planFinishDateFin2: presentTime(), // 结束时间
      },
      serviceTypeList: [],
      serviceData: [],
      paging: {
        total: 0, // 总页数
        page: null, // 当前页数
        rows: 10, // 每页的数量
      },
      record_config: {
        header: ["服务时间", "服务对象", "服务人员", "服务项目"],
        rowNum: 4,
        columnWidth: [80, 80, 80],
        headerBGC: "rgba(0,0,0,0)",
        oddRowBGC: "rgba(103, 118, 137, 0.3)",
        evenRowBGC: "rgba(0,0,0,0)",
        data: [],
      },
    };
  },
  async mounted() {
    this.getTableData();
    this.getServiceType(); // 获取服务类型
    await this.handelData();
  },
  methods: {
    async handelData() {
      this.$set(this.count_data[0], "count", this.nurseData.abilityEvaluate);
      this.$set(this.count_data[1], "count", this.nurseData.demandEvaluate);
      this.$set(this.count_data[2], "count", this.nurseData.takeCarePlanCount);
      this.$set(this.count_data[3], "count", this.nurseData.responseTimes);
      // 老人照护等级分布
      this.level_data = this.nurseData.elderNurseLevelList.map((item) => {
        return {
          value: item.num,
          name: item.levelName,
        };
      });
      // 老人照护等级分布
      this.level_data = this.nurseData.elderNurseLevelList.map((item) => {
        return {
          value: item.num,
          name: item.levelName,
        };
      });
      // 服务照护统计
      this.service_data = {
        grqj: this.nurseData.takeCarePlan1,
        yzcl: this.nurseData.takeCarePlan2,
        yszl: this.nurseData.takeCarePlan3,
        qjzh: this.nurseData.takeCarePlan4,
        other: this.nurseData.takeCarePlan5,
      };
      // 设备类型占比
      this.device_data = this.nurseData.iotDeviceCountList.map((item) => {
        return {
          value: item.number,
          name: item.typeName,
        };
      });
      this.drawChart();
    },
    showNurseModal() {
      this.monitorShow = true;
    },
    showMore() {
      this.$store.commit("setDrawer", true);
      this.$store.commit("setCurrentMenu", "nurse");
    },
    drawChart() {
      this.nurseChart = echarts.init(document.getElementById("nurse-chart2"));
      let nursrData = [
        {
          name: "专需护理",
          value: 469,
        },
        {
          name: "特三护理",
          value: 167,
        },
        {
          name: "特二护理",
          value: 183,
        },
        {
          name: "特一护理",
          value: 105,
        },
        {
          name: "一级护理",
          value: 582,
        },
        {
          name: "二级护理",
          value: 1531,
        },
        {
          name: "三级护理",
          value: 2,
        },
      ];
      this.nurseChart.setOption(roseChart(nursrData));
      this.lineChart = echarts.init(document.getElementById("line-chart2"));
      this.lineChart.setOption(lineChart(this.service_data));
      this.deviceChart = echarts.init(document.getElementById("device-chart"));
      this.deviceChart.setOption(roseChart2(this.device_data));
    },
    async getServiceType() {
      const { data: res } = await findBizServicePlanItemElementList();
      this.serviceTypeList = res.data.rows;
    },
    // 获取服务列表
    async apiGetServiceRecordListFunc() {
      let res = await planRecordBeanList({
        status: 1,
        // branchId: this.searchObj.branchId,
        // elderNameLike: this.searchObj.elderNameLike,
        // expenseItemId: this.searchObj.expenseItemId,
        ...this.searchObj,
        ...this.paging,
      });
      this.serviceData = res.data.data.rows;
      this.$set(this.paging, "total", res.data.data.total);
      // let table_arr = this.serviceData.
    },
    // 每页的数量
    mixinPagingSelectSize(size) {
      this.paging.rows = size;
      this.paging.page = null;
      this.apiGetServiceRecordListFunc();
    },
    // 当前第几页
    mixinPagingCurrentPage(page) {
      if (page === 1) {
        this.paging.page = null;
      } else {
        this.paging.page = page;
      }

      this.apiGetServiceRecordListFunc();
    },
    // 获取服务详细
    async getTableData() {
      let json = {
        branchId: 6627,
        rows: 100,
        status: 1,
      };
      try {
        let res = await planRecordBeanList(json);
        let table_arr = res.data.data.rows.map((item) => {
          let arr = [];
          arr[0] = item.finishTime ? item.finishTime.substring(5, 16) : "-";
          arr[1] = item.elderName;
          arr[2] = item.executor;
          arr[3] = item.expenseItem;
          return arr;
        });
        this.record_config = {
          header: ["服务时间", "服务对象", "服务人员", "服务项目"],
          rowNum: 4,
          columnWidth: [120, 80, 80],
          headerBGC: "rgba(0,0,0,0)",
          oddRowBGC: "rgba(103, 118, 137, 0.3)",
          evenRowBGC: "rgba(0,0,0,0)",
          waitTime: 9999999999,
          data: table_arr,
        };
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nuser-wrapper {
  width: 450px;
}
.count-con {
  width: 450px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .count-item {
    color: #fff;
    .count-title {
      font-size: 14px;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
    }
    .num {
      font-size: 26px;
      font-weight: normal;
      letter-spacing: 0.02em;
      font-weight: bold;
      .unit {
        font-size: 15px;
        color: #ffffff;
        font-weight: normal;
      }
    }
  }
}
.content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  color: #fff;
  span {
    font-size: 15px;
  }
  .left-con {
    .num {
      font-size: 26px;
      font-weight: normal;
    }
    .bed-code {
      font-size: 14px;
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      margin-top: 10px;
    }
    .help-sos {
      font-size: 14px;
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      margin-top: 20px;
    }
  }
  .right-con {
    margin-top: 10px;
    width: 50%;
    .chart-title {
      font-size: 16px;
      font-weight: normal;
      font-family: "Microsoft Yahei", Arial, "sans-serif";
      font-size: 16px;
      writing-mode: horizontal-tb;
    }
    #nurse-chart2 {
      width: 100%;
      height: 160px;
    }
  }
}
.line-chart-con {
  .title-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #fff;
    font-weight: normal;
    font-family: "Microsoft Yahei", Arial, "sans-serif";
    font-size: 16px;
    writing-mode: horizontal-tb;
    .title-icon {
      width: 38px;
      height: 38px;
      border-radius: 5px;
      background-image: url("../../assets/index/fwtj.svg");
      mask: url("../../assets/index/fwtj.svg") no-repeat 50% 50%;
      -webkit-mask-size: cover;
      background-color: rgb(197, 255, 255);
      mask-size: cover;
      margin-right: 10px;
    }
  }
  #line-chart2 {
    width: 100%;
    height: 200px;
  }
}
.title-through {
  color: #fff;
  font-size: 14px;
}
.nurse-data-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  margin-top: 5px;
  .data-item {
    font-size: 14px;
    .title {
    }
    .num {
      font-size: 24px;
      span {
        font-size: 12px;
      }
    }
  }
}
.nurse-record-con {
  .record-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 450px;
    line-height: 30px;
    color: #fff;
    .title-con {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .icon {
      width: 24px;
      height: 24px;
      background: url("../../assets/index/title-icon.png") no-repeat center;
      background-size: contain;
      vertical-align: middle;
    }
    .title {
    }
    .more {
      color: rgb(81, 218, 239);
      font-size: 14px;
      cursor: pointer;
    }
  }
}
.device-con {
  .device-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 450px;
    height: 60px;
    line-height: 60px;
    color: #fff;
    .icon {
      width: 24px;
      height: 24px;
      background: url("../../assets/index/title-icon.png") no-repeat center;
      background-size: contain;
      vertical-align: middle;
    }
    .title {
      font-size: 16px;
      span {
        color: rgb(238, 255, 5);
      }
    }
  }
  #device-chart {
    width: 400px;
    height: 200px;
  }
}
</style>
